// Звёздочка «В избранное» на карточке отеля, места, экскурсии или пакета тура (снимок карточки — shared/lib/saved)
import type { MouseEvent } from 'react';
import { toggleSaved, useIsSaved, type SavedCard } from '../lib/saved';
import { track } from '../lib/track';
import { Icon } from './Icon';
import { toast } from './Toast';

export function SaveStar({ card, className = '' }: { card: Omit<SavedCard, 'savedAt'>; className?: string }) {
  const on = useIsSaved(card.key);
  const click = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const now = toggleSaved(card);
    if (now) track('feature', { name: 'save_card', kind: card.kind });
    toast(now ? 'Сохранено в избранном' : 'Убрано из избранного');
  };
  return (
    <button type="button" className={`save-star${on ? ' on' : ''} ${className}`.trim()} data-save={card.key} aria-pressed={on}
      title={on ? 'Убрать из избранного' : 'В избранное'} aria-label={on ? `Убрать из избранного: ${card.title}` : `В избранное: ${card.title}`} onClick={click}>
      <Icon name="star" />
    </button>
  );
}
